<template>
  <div class="course-item">
    <a class="" @click="goTestPaperPage(data)">
      <div class="course-item-inner">
        <div class="course-cover"
             :style="'background-image: url('+data.picture_url+')'"></div>
        <div class="course-info">
          <div class="title">{{data.name}}</div>
          <div class="owner">
            <p>{{data.introduction}}</p>
          </div>
          <div class="desc">
            <div class="desc-item"><i class="level"></i> <span>{{data.complexity_name}}</span></div>
            <div class="desc-item"><i class="time"></i> <span>{{data.limited_time}} h</span></div>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script type="text/javascript">
  import {mapState} from "vuex";

  export default {
    data() {
      return {}
    },
    props: {
      data: {
        type: Object,
        require: true
      }
    },
    computed: {
      ...mapState({
        user_info: state => state.loginState.user_info,
      }),
    },
    methods: {
      goTestPaperPage(data) {
        // if (this.user_info.sysRoles[0].code == 'student') {
          if(data.tpaper_status == 1){
            this.$router.push({
              name: 'exerciseAnswer',
              params: {qb_id: data.id},
            })
          }else{
            this.$router.push({
              name: 'exerciseStart',
              params: {qb_id: data.id},
            })
          }
        // } else {
        //   this.$router.push({
        //     name: 'example',
        //     params: {
        //       id: data.id
        //     }
        //   })
        // }
      }
    },
  }
</script>

<style lang="less" scoped>
  .course-item {
    display: inline-block;
    width: 298px;
    padding: 0 12px;
    margin-bottom: 30px;
    box-sizing: border-box;
    position: relative;

    a {
      position: relative;
      display: inline-block;
      width: 100%;
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, .1), 0 2px 2px rgba(0, 0, 0, .2);
      transition: all .3s ease-in-out;
      bottom: 0
    }

    a:hover {
      bottom: 4px;
    }

    a:hover .course-item-inner {
      box-shadow: 0 3px 6px rgba(0, 0, 0, .2)
    }

    .course-item-inner {
      border-radius: 4px;

      .course-cover {
        width: 100%;
        height: 144px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }

      .course-info {
        padding: 18px;

        .title {
          font-size: 16px;
          color: #000;
          width: 100%;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 8px;
        }

        .owner {
          ont-size: 14px;
          color: #888;
          width: 100%;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .desc {
          margin-top: 30px;

          .desc-item {
            display: inline-block;
            margin-right: 20px;

            i {
              display: inline-block;
              width: 16px;
              height: 16px;
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
              margin-right: 5px;
              vertical-align: middle;
            }

            i.level {
              background-image: url(../../../../static/images/icon-level.svg);
            }

            i.time {
              background-image: url(../../../../static/images/icon-time.svg);
            }

            span {
              display: inline-block;
              font-size: 14px;
              color: rgba(0, 0, 0, .54);
              vertical-align: middle;
            }
          }
        }
      }
    }
  }


</style>
